import { render, staticRenderFns } from "./edit-update.vue?vue&type=template&id=03928958"
import script from "./edit-update.vue?vue&type=script&lang=js"
export * from "./edit-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports